import BasicModal from 'components/Modal';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { baseURL } from 'utils/api';
import MultiTag from 'components/MultiTag/index';
import SoftButton from 'components/SoftButton';
import SoftInput from 'components/SoftInput';
import { getLocationData } from 'api/commonSlice';
import toast from 'react-hot-toast';
import Loading from 'components/ApnaLoading';


const EditForm = ({ show, unShow, offerId, type, handelRefresh, setShowTerm }) => {

    const locations = useSelector((state) => state.commonSlice?.locations);
    const dispatch = useDispatch();
    const [allLocations, setAllLocations] = useState([]);
    const [loading, setLoading] = useState(false);

    const [values, setValues] = React.useState({
        pin: '',
        estimatedSaving: '',
        locations: []
    });

    useEffect(() => {
        if (offerId) {
            setLoading(true)
            fetch(`${baseURL}/business-template-details/${offerId}/${localStorage.getItem('id')}`)
                .then(res => res.json())
                .then(data => {
                    if (data.status === 200) {
                        setLoading(false)
                        if (data?.data?.locations?.length > 0) {

                            setValues({
                                pin: data?.data?.passcode || "",
                                estimatedSaving: data?.data?.savingPoints || '',
                                locations: []
                            });

                            data?.data?.locations &&
                                data?.data?.locations.length > 0 &&
                                data?.data?.locations.forEach((location) => {
                                    setValues((prev) => ({
                                        ...prev,
                                        locations: [...(prev.locations || []), { _id: location?.locationId, name: location?.locationName }],
                                    }));
                                });
                        } else {
                            setValues({
                                pin: '',
                                estimatedSaving: '',
                                locations: []
                            });
                        }
                    } else {
                        setLoading(false)
                        toast.error(data.message)
                        setValues({
                            pin: '',
                            estimatedSaving: '',
                            locations: []
                        })
                    }
                }).catch(err => {
                    setLoading(false)
                    toast.error(err.message || 'Something went wrong');
                });
        }
        dispatch(getLocationData());
    }, [offerId]);

    useEffect(() => {
        if (locations) {
            setAllLocations([]);
            locations &&
                locations.length > 0 &&
                locations.map((location, i) => {
                    setAllLocations((prev) => [...prev, { _id: location?.locationId, name: location?.locationName ? location?.locationName : `location-${i}` }]);
                })
        }
    }, [locations])

    const handleSubmit = (e) => {
        e.preventDefault();

        if (values.locations.length === 0) {
            toast.error('Please select locations');
            return;
        };

        if (!parseInt(values.estimatedSaving) > 0) {
            toast.error('Please estimated saving amount more than 0');
            return;
        }

        const findOriginalLocation = values.locations.map((location) => {
            const match = locations.find((loc) => loc.locationId === location._id);
            if (match) {
                return { locationId: match.locationId, locationName: match.locationName };
            }
            return null;
        });

        if (type === 'edit') {

            fetch(`${baseURL}/update-business-template-details`, {
                method: 'PUT',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    businessUserId: localStorage.getItem('id'),
                    offerId: offerId,
                    passcode: values.pin,
                    savingPoints: parseInt(values.estimatedSaving),
                    locations: findOriginalLocation
                })
            }).then(res => res.json())
                .then(data => {
                    handelRefresh()
                    if (data.status === 200) {
                        unShow();
                        toast.success('Updated Successfully')
                    } else {
                        toast.error(data.message)
                    }
                }).catch(err => {
                    toast.error(err.message || 'Something went wrong');
                });
        } else {
            fetch(`${baseURL}/add-offer-details`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    businessUserId: localStorage.getItem('id'),
                    passcode: values.pin,
                    savingPoints: values.estimatedSaving,
                    locations: findOriginalLocation,
                    offerId: offerId
                })
            }).then(res => res.json())
                .then(data => {
                    if (data.status === 200) {
                        unShow();
                        setShowTerm(true);
                        toast.success('Now you can activate the offer')
                    } else {
                        toast.error(data.message)
                    }
                }).catch(err => {
                    toast.error(err.message || 'Something went wrong');
                });
        }

    }

    const handleChangeLocations = (e, value) => {
        setValues({ ...values, locations: value });
    };

    const handelCancel = () => {
        unShow();
    };

    useEffect(() => {
        if (!show) {
            setValues({
                pin: '',
                estimatedSaving: '',
                locations: []
            });
        }
    }, [show]);

    return (
        <BasicModal show={show} unShow={unShow}>
            {
                loading ? <Loading /> :

                    <form onSubmit={handleSubmit}>

                        <SoftBox>
                            <SoftTypography
                                variant="caption"
                            >
                                Locations *
                            </SoftTypography>
                            {
                                locations && locations.length > 0 &&
                                <MultiTag
                                    required
                                    value={values.locations}
                                    label="locations *"
                                    placeholder="Select Locations"
                                    onChange={handleChangeLocations}
                                    data={allLocations}

                                />
                            }

                        </SoftBox>

                        <SoftBox>
                            <SoftTypography
                                variant="caption"
                            >
                                Pin *
                            </SoftTypography>
                            <SoftInput
                                required
                                value={values.pin}
                                onChange={e => {
                                    const value = e.target.value;
                                    // Allow only numbers and limit to 4 digits
                                    if (/^\d{0,4}$/.test(value)) {
                                        setValues({ ...values, pin: value });
                                    }
                                }}
                                name="pin"
                                placeholder="Enter 4-digit Pin"
                                type="text"
                                maxLength="4"
                                pattern="\d{4}" // HTML validation for exactly 4 digits
                                title="Please enter a 4-digit PIN"
                            />

                        </SoftBox>
                        <SoftBox>
                            <SoftTypography variant="caption">
                                Estimated Saving (Round to next $) *
                            </SoftTypography>
                            <SoftInput
                                required
                                value={values.estimatedSaving}
                                onChange={(e) => {
                                    const inputValue = e.target.value;
                                     if(inputValue=='' || inputValue>0){
                                        setValues({ ...values, estimatedSaving: inputValue });
                                    }
                                }}
                                name="estimatedSaving"
                                placeholder="Enter estimated saving (greater than 0)"
                                type="text"
                            />
                        </SoftBox>

                        <SoftBox
                            sx={{ mt: 4 }}
                            display="flex"
                            justifyContent="space-between"
                            gap={2}
                        >
                            <SoftButton variant="outlined" color="info"
                                onClick={handelCancel}
                                fullWidth
                            >
                                Cancel
                            </SoftButton>
                            <SoftButton
                                fullWidth
                                variant="gradient"
                                color="info"
                                sx={{ color: 'white', marginRight: 2 }}
                                type="submit"
                            >
                                Save Changes
                            </SoftButton>


                        </SoftBox>

                    </form>
            }



        </BasicModal>
    )
}

export default EditForm